import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { CurrentMedicationModel } from 'src/app/models/CurrentMedicationModel';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { CurrentMedicationService } from 'src/app/services/CurrentMedicationService';
import { DrugInteractionSevice } from 'src/app/services/DrugInteractionSevice';
import { DrugInteractionModel } from 'src/app/models/DrugInteractionModel';
import { DomSanitizer } from '@angular/platform-browser';
import { DrugInteractionViewComponent } from '../drug-interaction-view/drug-interaction-view.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ItemsService } from 'src/app/services/ItemsService';
import { UnitsService } from 'src/app/services/UnitsService';
import swal from 'sweetalert2';
import { ReportdialogComponent } from '../reportdialog/reportdialog.component';

@Component({
  selector: 'app-current-medication',
  templateUrl: './current-medication.component.html',
  styleUrls: ['./current-medication.component.css']
})
export class CurrentMedicationComponent implements OnInit {

  ////===================== Current Medication ====================
    patientcode = '';
    cmdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    drugref = '' ;
    drugname = '' ;
    dose = '' ;
    uom = '' ;
    route = '' ;
    duration = '' ;
    gencomplaint = '' ;
    frequancy = '' ;
    cmdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    docDate  =formatDate(new Date(), 'yyyy-MM-dd', 'en');
    cmsource = '' ;
    cmdoctor = '' ;
    compcode = '' ;
    userid = '' ;
    modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    ittname = '' ;
    unname = '' ;
   
///---------------------- Drug Interaction ----------------------------------
      divisitserial = 0 ;
      didescription = '' ;
      dinotes = '' ;
      diimage :any ;
      myimage :any;
      imageSrc;
      imageSource: any;
      disablepharnacy = false;
      sellersPermitFile: any;
      sellersPermitString :any;
      didescriptiontext =''
///-----------------------------------------------------------------------------
    itemsList2: ItemsModel[] =[];
    unitsList: UnitsModel[] = [];
///==============================================================================
 editorConfigNoToolbar = {
    editable: true,
    spellcheck: true,
    showToolbar: true,  // 🚫 This hides the toolbar
    height: '250px',
    frameElement:true,
    minHeight: '0',
    placeholder: '',
    translate: 'yes',
    defaultParagraphSeparator: '',
    defaultFontName: '',

    toolbarHiddenButtons: []
  };
  currentmedication : CurrentMedicationModel[]=[];
  @Output() submitClicked = new EventEmitter<any>();
  constructor(public cmedication : CurrentMedicationModel,
    public storage: LocalStorageService,
    public itemsService : ItemsService,
    public unitsService: UnitsService,
    public cmedicationService : CurrentMedicationService,
    public druginteractionservice : DrugInteractionSevice,
    public druginteraction :DrugInteractionModel,
    private sanitizer: DomSanitizer,
    private dialogref: MatDialog,
    @Inject(MAT_DIALOG_DATA)public data: any
  ) {
    this.patientcode = data.wk_patientcode;
    this.cmsource = data.wk_source;
    this.docDate = data.wk_date;
    this.disablepharnacy = data.disablepharnacy;
   }


  ngOnInit(): void {
    this.retriveItems();
    this.retriveUnitsLookupTop();
    this.retriveCMedication();
    this.retriveDrugInteraction();
  }
  retriveItems(){
    this.itemsService.getItemsLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: ItemsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.itemsList2[i] = data[i];
      }

    })
  }
  updatePlainText() {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = this.dinotes || '';
    this.didescriptiontext = tempElement.textContent || '';
  }
  retriveUnitsLookupTop() {
    this.unitsService
      .getUnitsLookupTop(this.storage.retrieve('stgcompCode'))
      .subscribe((data: UnitsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.unitsList[i] = data[i];
        }

      });
  }
  SelectCurrent(cur: CurrentMedicationModel) {

    this.drugref = cur.drugref;
    this.drugname = cur.drugname ;
    this.cmdate = cur.cmdate;
    this.dose = cur.dose;
    this.uom = cur.uom ;
    this.route = cur.route ;
    this.duration = cur.duration ;
    this.gencomplaint = cur.gencomplaint ;
    this.frequancy = cur.frequancy ;
    this.ittname = cur.ittname ;
    this.unname = cur.unname ;

    this.submitClicked.emit(this.cmedication);

  }
  submitCMedication() {
    if (this.patientcode == null || this.patientcode == '') {
      return;
    }
    this.cmedication.patientcode = this.patientcode;

    this.cmedication.cmdate = formatDate(this.cmdate, 'yyyy-MM-dd', 'en');
    this.cmedication.drugref = this.drugref ;
    this.cmedication.drugname = this.drugname ;
    this.cmedication.dose =this.dose ;
    this.cmedication.uom = this.uom;
    this.cmedication.route = this.route ;
    this.cmedication.duration = this.duration ;
    this.cmedication.gencomplaint = this.gencomplaint ;
    this.cmedication.frequancy = this.frequancy ;
    this.cmedication.cmdate1 = formatDate(this.cmdate1, 'yyyy-MM-dd', 'en');
    this.cmedication.cmsource = 'Current Medication' ;

    this.cmedication.cmdoctor = this.storage.retrieve('stguserId'); ;
    this.cmedication.userid = this.storage.retrieve('stguserId');
    this.cmedication.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
    this.cmedication.compcode = this.storage.retrieve('stgcompCode');

    this.cmedicationService.AddCurrentMedication(this.cmedication).subscribe(
      (data) => {
        this.retriveCMedication();
        this.NewDataCurrentMedication();
      },
      (error) => {
        alert(error);
      }
    );
  }
  retriveCMedication()
{
  this.currentmedication = [];
  this.cmedicationService.getCurrentMedicationAll(this.patientcode,'Current Medication',this.storage.retrieve('stgcompCode'))
    .subscribe((data: CurrentMedicationModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.currentmedication[i] = data[i];
      }

      //this.NewDataCurrentMedication();
    });
    this.retriveDrugInteraction();
}
NewDataCurrentMedication(){
  this.drugref = '' ;
  this.drugname = '' ;
  this.dose = '' ;
  this.uom = '' ;
  this.route = '' ;
  this.duration = '' ;
  this.gencomplaint = '' ;
  this.frequancy = '' ;
  this.ittname = '' ;
  this.unname = '' ;

}
retriveDrugInteraction()
{

  this.druginteractionservice.getDrugInteraction(1,this.patientcode ,this.storage.retrieve('stgcompCode'))
  .subscribe((data: DrugInteractionModel) => {

    if (data.divisitserial == null) {
      this. NewDrugInteractionData();
      return;
    }

    this.didescription = data.didescription ;
    this.dinotes = data.dinotes ;
    this.myimage = data.diimage;
    this.sellersPermitString =  data.diimage;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;
    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
  }
  );

}
NewDrugInteractionData()
{

  this.divisitserial = 0 ;
  this.didescription = '' ;
  this.dinotes = '' ;
  this.diimage ='' ;
  this.myimage = '';

}
delCurrentMedication_Line() {

  this.cmedicationService.delCurrentMedication(this.patientcode,this.drugref,this.storage.retrieve('stgcompCode')).subscribe((data: CurrentMedicationModel) => {
        this.retriveCMedication();
    });
  }
  openDialogViwer(){
    this.storage.store('stgvisverial', 1);
    this.storage.store('stgcpatientCode', this.patientcode);
    const dialogRef = this.dialogref.open(DrugInteractionViewComponent,
      {
        data: {
          dataKey: this.druginteraction
        }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();

      });
  }

  public picked(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.sellersPermitFile = file;
      this.handleInputChange(file); //turn into base64

    }
    else {
      alert("No file selected");
    }
  }
  handleInputChange(files: any) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }

    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e: any) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.sellersPermitString = base64result;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;

    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);


  }
  Save_Data(){

    if (this.divisitserial == null || this.sellersPermitString == null) {
      return;
    }
    this.druginteraction.divisitserial = 1;
    this.druginteraction.patientcode = this.patientcode;
    this.druginteraction.didescription = this.didescription;
    this.druginteraction.dinotes = this.dinotes;

    this.druginteraction.userid = this.storage.retrieve('stguserId');
    this.druginteraction.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.druginteraction.compcode = this.storage.retrieve('stgcompCode');

    this.druginteraction.diimage = this.sellersPermitString;
    this.druginteractionservice.Adddruginteraction(this.druginteraction).subscribe(data => {
    },
      error => { alert(error); }

    );
    this.druginteractionservice.AdddruginteractionImage(this.druginteraction).subscribe(data => {
    },
      error => { alert(error); }
    );
    this.mesgSave();
  }
  Exit_Data(){
    this.dialogref.closeAll();
  }
  Print_Home_Medication(){
     this.storage.store('stgPar', this.patientcode);
     this.storage.store('stgDate', this.docDate);
     this.storage.store('stgSource', 'Current Medication');

        ////******************************** */
            const dialogRef = this.dialogref.open(ReportdialogComponent,
              {
                data: {
                  reportUrl: 'CocReports/Prescription',

                },
                width: '40vw',
                height: '90vw',
              });
            dialogRef.afterClosed().subscribe(result => {
            });

            const dialogSubmitSubscription =
              dialogRef.componentInstance.submitClicked.subscribe(result => {
                dialogSubmitSubscription.unsubscribe();
              });
  }
    mesgSave() {
      swal({
        title: 'Your work has been saved',
        type: 'success',
        showConfirmButton: false,

        timer: 1500,
      });
    }
}
